import { render, staticRenderFns } from "./MailSendDialog.vue?vue&type=template&id=0ca4ca30&scoped=true&"
import script from "./MailSendDialog.vue?vue&type=script&lang=js&"
export * from "./MailSendDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca4ca30",
  null
  
)

export default component.exports